// A printed single-use code stays in the URL fragment until this local read.
// It is never a query parameter, telemetry field or authentication authority.
/** A printed voucher code, as its card shows it (services domain/vouchers.ts makes them). */
export const issuedBatchCode = /^(?:LIFE|[A-HJ-NP-Z2-9]{2,10})(?:-[A-HJ-NP-Z2-9]{5}){3}$/u;

export function consumeVoucherFragment(fragment: string): string {
  const parameters = new URLSearchParams(fragment.replace(/^#/, ""));
  const values = parameters.getAll("voucher");
  if (values.length === 0) return "";

  // Parse the supplied router snapshot, rather than rereading the cleared URL.
  // React StrictMode may initialize twice with that same snapshot.
  if (typeof window !== "undefined" && window.location.hash)
    window.history.replaceState(
      window.history.state,
      "",
      `${window.location.pathname}${window.location.search}`,
    );

  const value = values.length === 1 ? values[0]!.trim().toUpperCase() : "";
  return value.length <= 96 && issuedBatchCode.test(value) ? value : "";
}
